import { QuickstartTheme } from '../types/theme';
import { detectPlatform } from './environmentDetection';

const VIDEO_EXTENSION = /\.(mp4|webm|mov|m4v)(\?|$)/i;

export const isPlayableVideoUrl = (url: string | undefined): url is string =>
  !!url && VIDEO_EXTENSION.test(url);

const pushUnique = (urls: string[], url: string | undefined): void => {
  if (isPlayableVideoUrl(url) && !urls.includes(url)) urls.push(url);
};

/**
 * Micro-trailer first, then gameplay. Never prefers a still.
 * iOS tries the per-device clip first when one exists.
 */
export const collectStageVideoUrls = (
  theme: QuickstartTheme,
  platform: string = typeof navigator !== 'undefined' ? detectPlatform() : 'Unknown',
): string[] => {
  const urls: string[] = [];
  const ios = platform === 'iOS';
  const slots = [theme.trailerBackgroundVideo, theme.loadingBackgroundVideo];

  for (const slot of slots) {
    if (ios) {
      pushUnique(urls, slot?.videoUrlIos);
      pushUnique(urls, slot?.videoUrl);
    } else {
      pushUnique(urls, slot?.videoUrl);
      pushUnique(urls, slot?.videoUrlIos);
    }
  }

  return urls;
};
